import { render, staticRenderFns } from "./LookupAdmin.vue?vue&type=template&id=315d8dc2&scoped=true"
import script from "./LookupAdmin.vue?vue&type=script&lang=js"
export * from "./LookupAdmin.vue?vue&type=script&lang=js"
import style0 from "./LookupAdmin.vue?vue&type=style&index=0&id=315d8dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d8dc2",
  null
  
)

export default component.exports